import { on } from 'delegated-events'
import { slideToggle } from '../common/slide'

const fn = {
  init: () => {
    on('click', '[data-slide-classtoggle]', fn.handleToggle)
    on('keyup', '[data-slide-classtoggle]', fn.handleToggle)
  },

  handleToggle: (e) => {
    if (e.type === 'keyup' && e.keyCode !== 13) {
      return
    }

    const trigger = e.target.closest('[data-slide-classtoggle]')

    if (!trigger) {
      return
    }

    let targets = document.getElementsByClassName(trigger.getAttribute('aria-controls'))

    targets = [...targets]

    if (!targets) {
      return
    }

    if (trigger.getAttribute('aria-expanded') === 'false') {
      trigger.getElementsByTagName('span')[0].classList.add('opened')
      trigger.setAttribute('aria-expanded', 'true')
      trigger.setAttribute('aria-label', 'Close')
      trigger.setAttribute('title', 'Close')
    }
    else {
      trigger.getElementsByTagName('span')[0].classList.remove('opened')
      trigger.setAttribute('aria-expanded', 'false')
      trigger.setAttribute('aria-label', 'View more information')
      trigger.setAttribute('title', 'View more information')

    }
    targets.forEach(function(target) {
      if (trigger.getAttribute('aria-expanded') === 'false') {
        //target.parentNode.classList.remove('self-start')
        //fn.selfStart(target.parentNode)
        slideToggle(target)
      } else {
        //target.parentNode.classList.add('self-start')
        //fn.selfStart(target.parentNode)
        slideToggle(target)
      }
    })
  },

  selfStart: (e) => {
    if (e.classList.contains('proj-desc')) {
      var el = e.nextElementSibling
      for (let i=1; i<=4; i++) {
        el.classList.toggle('self-start')
        el = el.nextElementSibling
      }
    }
    else if (e.classList.contains('org-desc')) {
      var org = e.previousElementSibling
      org.classList.toggle('self-start')
    }
  },
}

export default {
  can: () => true,
  run: fn.init,
}
